<template>
  <div class="page">
    <commonHeader heading="数字化教学评估" subtitle="全部数据">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <!-- 学员学习数据 -->
    <!-- <div class="big-title">
      <div class="left-title">全部数据</div>
    </div> -->
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="知识类型" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="课程名称" hide-details solo
            clearable></v-text-field>
            <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="任务名称" hide-details solo
            clearable></v-text-field>
            <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="教学策略名称" hide-details solo
            clearable></v-text-field>
          <v-btn depressed color="primary">
            搜索
          </v-btn>
          <v-btn depressed>
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table hide-default-footer :headers="headers" :items="desserts" :items-per-page="5"
            class="elevation-1"></v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination class="table-pagination" prev-icon="fa fa-angle-left" next-icon="fa fa-angle-right"
            color="#4caf50" :value="pagination.page" :length="1" circle :total-visible="7"></v-pagination>
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      selectMetaListData: [{ text: '水电费', value: 1 }, { text: '让突然', value: 2 }],

      dateMenu: false,
      headers: [
        {
          text: '知识类型',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: '所属课程', value: 'calories' },
        { text: '任务名称', value: 'fat' },
        { text: '教学策略', value: 'carbs' },
        { text: '任务累计学习人次', value: 'protein' },
        { text: '课程结业人数', value: 'iron1' },
        { text: '知识点关联测试得分率', value: 'iron2' },
        { text: '话题互动次数', value: 'iron3' },
        { text: '课程完学率', value: 'iron4' },
      ],
      desserts: [
        {
          name: '程序',
          calories: '无人机驾驶员',
          fat: '任务1.3',
          carbs: 'A老师的教学策略',
          protein: 1856,
          iron1: 26310,
          iron2: '80%',
          iron3: 90,
          iron4: 1.0,
        },
        {
          name: '概念',
          calories: '无人机驾驶员',
          fat: '任务1.4',
          carbs: 'B老师的教学策略',
          protein: 1601,
          iron1: 32310,
          iron2: '90%',
          iron3: 96,
          iron4: 1.0,
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
        // name: "",
        perPageOptions: [8, 12, 16, 20],
      },


    };
  },

  created() {

  },

  mounted() {
    this.getTableList()
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'DigitalTeachingDesign',
      });
    },
    getTableList() { },

  }
}
</script>

<style scoped>
.page {
  padding: 0 15px;

  .big-title {
    display: flex;
    padding: 15px 15px 5px 15px;

    .left-title {    
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-return {
      text-align: right;
      font-size: 18px;
    }
  }

  .table-data {
    .v-card {
      padding: 15px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}
</style>